module.exports = __webpack_public_path__ + "static/media/menu.ffd5eecd.svg";